var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]),_vm._t("default")],2),_c('img',{attrs:{"src":_vm.icon,"width":"62","height":"62"}})])}
var staticRenderFns = []

export { render, staticRenderFns }